import { Navigate, Route, Routes } from "react-router-dom";

import {
	PersonalInformationPage,
	ManageDriversPage,
	ManageBankAccountsPage,
	ManageVehiclesPage
} from "pages";

export default function RegistrationRoutes(): JSX.Element {
	return (
		<>
			<Route path="" element={<Navigate to="informacoes-pessoais" replace />} />
			<Route
				path="informacoes-pessoais"
				element={<PersonalInformationPage />}
			/>
			<Route path="veiculos" element={<ManageVehiclesPage />} />
			<Route path="motoristas" element={<ManageDriversPage />} />
			<Route path="contas" element={<ManageBankAccountsPage />} />
		</>
	);
}
